export default async function recaptchaAuth (vueInstance) {
  const captchaLoaded = await vueInstance.$recaptchaLoaded()
  if (captchaLoaded) {
    return vueInstance.$recaptcha('login')
  }
  return new Promise(function (resolve, reject) { reject(Error('Captcha Error')) })
}
